<app-page-wrapper>

    <div class="verify-result-wrapper" *ngIf="result || hasReachedAttemptLimit">

        <app-icon-prompt-card *ngIf="isVerified" header="Membership Verified" label="Verification Result"
            iconURL="assets/svg/verified-check.svg" iconColor="var(--color-green)"
            desc="Your documentation looks good and you can continue to the app.  This also gives you the ability to create invite codes from your profile."></app-icon-prompt-card>

        <app-icon-prompt-card *ngIf="isSoftVerified" header="Document Accepted" label="Verification Result"
            iconURL="assets/svg/verified-check.svg" iconColor="var(--color-green)"
            desc="Your document was accepted and you can continue. It will still be reviewed, and we may ask for more detailed information later."></app-icon-prompt-card>

        <app-icon-prompt-card *ngIf="error" header="Verification Failed" label="Verification Result"
            iconURL="assets/svg/x-octo-outline.svg" iconColor="var(--color-red)"
            desc="Make sure the document is a valid itinerary, a PDF file (not an image), and your information is in the itinerary. If you continue to have issues, email support@tailone.ai"></app-icon-prompt-card>

        <app-icon-prompt-card *ngIf="isNeedReview" header="Needs Review" label="Verification Result"
            iconURL="assets/svg/clock-solid.svg" iconColor="var(--color-yellow)"
            desc="Your document requires additional review. You will receive an email when your membership is verified or if we need any additional information. This generally takes less than 1 business day"></app-icon-prompt-card>

        <app-icon-prompt-card *ngIf="hasReachedAttemptLimit" header="Maximum Attempts Reached"
            label="Verification Result" iconURL="assets/svg/x-octo-outline.svg"
            iconColor="var(--color-red)"
            desc="You've reached the maximum number of document upload attempts. Email support@tailone.ai for help verifying your membership."></app-icon-prompt-card>

        <app-primary-btn mt="24px" *ngIf="isVerified || isSoftVerified" (click)="onClickContinue()" gradient="true">
            Continue
        </app-primary-btn>

        <app-text-button *ngIf="!hasReachedAttemptLimit && !isVerified" (handleClick)="startOver()" mt="14px" text="Try Again"></app-text-button>

    </div>

    <div class="verify-membership-wrapper" *ngIf="!result && !hasReachedAttemptLimit">

        <app-heavy-header mb="32px" title="Verify Membership"
            [description]="providerInstructions"></app-heavy-header>

        <app-alert-message *ngIf="requiresHardReview" type="error" mb="16px">{{ hardReviewMessage }}</app-alert-message>

        <div class="loader-wrap" *ngIf="isProcessing">
            <app-spinner size="32px"></app-spinner>
        </div>

        <div class="file-row" *ngIf="!isProcessing">
            <div class="form-wrapper" *ngIf="!isProcessing && !isNeedReview && !isVerified && !error && !hasReachedAttemptLimit">
                <div class="file-upload" (drop)="onFileSelected($event)" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" [ngClass]="{'dragging': isDragOver}">
                    <p>Drag and Drop or <span class="select-span">Choose File</span></p>
                    <input type="file" accept="application/pdf" (change)="onFileSelected($event)" />
                    <div *ngIf="file" class="file-info">
                        <p>{{ file.name }} ({{ file.size / 1024 | number: '1.0-0' }} KB)</p>
                    </div>
                </div>
                <p class="instructions" *ngIf="membership?.provider === 'NetJets' ">Find the PDF that looks like the one on the right.</p>

                <p class="instructions">Ensure it has your name and is a PDF and not a screenshot.</p>
                <p class="instructions" *ngIf="!requiresHardReview">If we can detect your provider, you can continue while your document is reviewed.</p>
                <p class="instructions" *ngIf="requiresHardReview">This submission must be fully approved before you can continue.</p>
            </div>

            <div class="doc-animation" *ngIf="!isLoadingProviderData">
                <app-itinerary-animation [isGeneric]="membership?.provider !== 'NetJets'"/>
            </div>
        </div>

        <div class="result-wrapper" *ngIf="error && !isProcessing && !isVerified && !isNeedReview">
            <app-alert-message type="error" mb="12px">{{error}}</app-alert-message>
        </div>

        <div class="actions"  *ngIf="!isProcessing">
            <!-- <app-primary-btn mb="12px" (click)="onClickContinue()" *ngIf="isVerified || isNeedReview">
                Continue
            </app-primary-btn>
            <app-secondary-btn mb="12px" (click)="startOver()" *ngIf="error && !hasReachedAttemptLimit">
                Start Over
            </app-secondary-btn> -->
            <app-text-button (handleClick)="onClickBack()" mt="14px" text="Go Back"></app-text-button>
        </div>

    </div>
</app-page-wrapper>
